<template>
    <div class="container">
        <img v-if="seen" class="top-img" src="../../assets/banner-xwzx.png" />
        <img v-else class="top-img" src="../../assets/banner_xwzx@2x.png" />
        <div v-if="seen" class="main">
            <div class="tabs-box">
                <div
                    class="tab"
                    :class="{ 'active-tab': activeTab === '1' }"
                    @click="changeTabs('1')"
                >
                    全部
                </div>
                <div
                    class="tab"
                    :class="{ 'active-tab': activeTab === '2' }"
                    @click="changeTabs('2')"
                >
                    行业新闻
                </div>
                <div
                    class="tab"
                    :class="{ 'active-tab': activeTab === '3' }"
                    @click="changeTabs('3')"
                >
                    公司新闻
                </div>
            </div>
            <div class="list-box">
                <div class="list">
                    <div
                        v-for="item in list"
                        :key="item.id"
                        class="list-item"
                        @click="checkContent(item)"
                    >
                        <div class="date">
                            <div class="year-month">{{ getDate(item.createTime) }}</div>
                            <div class="day">{{ getDay(item.createTime) }}</div>
                        </div>
                        <div class="content">
                            <div class="title line2">{{ item.title }}</div>
                            <div class="sub-title line3">{{ item.subTitle }}</div>
                            <button v-if="item.paidFlag == 1" class="paid-button" type="button">
                                收费文章
                            </button>
                        </div>
                        <img class="img" :src="item.titleImg" />
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page.sync="pageNum"
                        :page-size="pageSize"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
        <div v-else class="main">
            <div class="tabs-box">
                <div
                    class="tab"
                    :class="{ 'active-tab': activeTab === '1' }"
                    @click="changeTabs('1')"
                >
                    全部
                </div>
                <div
                    class="tab"
                    :class="{ 'active-tab': activeTab === '2' }"
                    @click="changeTabs('2')"
                >
                    行业新闻
                </div>
                <div
                    class="tab"
                    :class="{ 'active-tab': activeTab === '3' }"
                    @click="changeTabs('3')"
                >
                    公司新闻
                </div>
            </div>
            <div class="list-box">
                <div class="list">
                    <div
                        v-for="item in list"
                        :key="item.id"
                        class="list-item"
                        @click="checkContent(item)"
                    >
                        <img class="img" :src="item.titleImg" />
                        <div class="title line2">{{ item.title }}</div>
                        <button v-if="item.paidFlag == 1" class="paid-button" type="button">
                            收费文章
                        </button>
                        <div class="time">{{ item.createTime }}</div>
                    </div>
                </div>
                <div class="pagination">
                    <el-pagination
                        small
                        @current-change="handleCurrentChange"
                        :current-page.sync="pageNum"
                        :page-size="pageSize"
                        layout="total, prev, pager, next"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { request } from '@/api/auth'

export default {
    name: 'NewsListPage',
    data() {
        return {
            activeTab: '1',
            total: 0,
            pageNum: 1,
            pageSize: 5,
            list: []
        }
    },
    computed: {
        seen() {
            // 屏幕尺寸
            let screenWidth = document.body.clientWidth
            if (screenWidth > 768) {
                return true
            } else {
                return false
            }
        }
    },
    created() {
        this.getList()
    },
    methods: {
        changeTabs(val) {
            this.activeTab = val
            this.pageNum = 1
            this.getList()
        },

        getList() {
            const contentType = this.activeTab === '2' ? '0' : this.activeTab === '3' ? '1' : ''
            request
                .get('/szg-admin/common/news/list', {
                    params: {
                        pageNum: this.pageNum,
                        pageSize: this.pageSize,
                        contentType
                    }
                })
                .then((response) => {
                    this.list = response.rows
                    this.total = response.total
                })
        },

        handleCurrentChange() {
            this.getList()
        },

        getDate(val) {
            const date = val.split(' ')[0]
            const year = date.split('-')[0]
            const month = date.split('-')[1]
            return year + '-' + month
        },

        getDay(val) {
            const date = val.split(' ')[0]
            const day = date.split('-')[2]
            return day
        },

        checkContent(item) {
            // 第三方链接则跳转
            if (item.textContent === '0' && item.text) {
                window.open(item.text)
            } else if (item.textContent === '1') {
                this.$router.push({ name: 'NewsDetail', params: { id: item.id } })
            }
        }
    }
}
</script>

<style scoped lang="scss">
.container {
    width: 100%;

    ::v-deep .el-pager li.active {
        color: #15803c;
    }
    ::v-deep .el-pager li:hover {
        color: #15803c;
    }
    ::v-deep .btn-next:hover {
        color: #15803c;
    }
    ::v-deep .pre-next:hover {
        color: #15803c;
    }

    .line2 {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
    }
    .line3 {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 3; //行数
        line-clamp: 3;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
    }

    .top-img {
        width: 100%;
        height: 400px;
    }

    .main {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        .tabs-box {
            width: 1220px;
            display: flex;
            margin-top: 42px;
            margin-bottom: 30px;
            .tab {
                width: 194px;
                height: 66px;
                font-size: 1.375rem;
                color: #2f9458;
                margin-right: 56px;
                background: #ffffff;
                box-shadow: 0px 3px 10px 0px rgba(21, 128, 60, 0.27);
                border-radius: 5px;
                text-align: center;
                line-height: 66px;
                &:hover {
                    cursor: pointer;
                }
            }

            .active-tab {
                color: #fff;
                background: #2f9458;
                box-shadow: 0px 3px 10px 0px rgba(21, 128, 60, 0.27);
            }
        }

        .list-box {
            width: 1220px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .list {
                width: 100%;
                margin-bottom: 30px;

                .list-item {
                    height: 260px;
                    background: #ffffff;
                    box-shadow: 0px 4px 12px 0px rgba(47, 49, 55, 0.1);
                    border-radius: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    box-sizing: border-box;
                    padding: 30px;
                    margin-bottom: 30px;

                    .date {
                        background: #e2f6ea;
                        height: 110px;
                        width: 110px;
                        padding: 21px;
                        box-sizing: border-box;
                        margin-right: 50px;

                        .year-month {
                            color: #666666;
                            font-size: 1rem;
                            text-align: center;
                        }

                        .day {
                            font-weight: bold;
                            font-size: 2.375rem;
                            text-align: center;
                            margin-top: 5px;
                        }
                    }

                    .content {
                        width: 560px;

                        .title {
                            font-weight: bold;
                            font-size: 1.5rem;
                        }

                        .sub-title {
                            font-size: 1rem;
                            color: #999999;
                            line-height: 26px;
                            margin-top: 25px;
                        }
                    }

                    .paid-button {
                        height: 32px;
                        padding: 0 18px;
                        margin-top: 16px;
                        color: #2f9458;
                        font-size: 14px;
                        font-weight: 500;
                        background: #ffffff;
                        border-radius: 3px;
                        border: 1px solid #2f9458;
                        cursor: pointer;
                    }

                    .img {
                        width: 356px;
                        height: 200px;
                        margin-left: 50px;
                        object-fit: cover;
                    }
                }
            }
            .pagination {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                margin-bottom: 30px;
            }
        }
    }

    @media screen and (max-device-width: 768px) {
        .top-img {
            width: 100%;
            height: 136px;
        }

        .main {
            .tabs-box {
                width: 100%;
                display: flex;
                margin: 10px 0;
                .tab {
                    width: 88px;
                    height: 36px;
                    font-size: 0.875rem;
                    line-height: 36px;
                    margin-left: 20px;
                    margin-right: 0;
                }
            }

            .list-box {
                width: 100%;

                .list {
                    .list-item {
                        height: 100px;
                        padding: 10px;
                        border-radius: 0;
                        align-items: flex-start;
                        position: relative;

                        .img {
                            width: 142px;
                            height: 80px;
                            margin-left: 0;
                            object-fit: contain;
                        }

                        .title {
                            font-weight: bold;
                            font-size: 0.875rem;
                            color: #333740;
                            line-height: 1.25rem;
                            width: calc(100% - 160px);
                            padding-right: 6px;
                        }

                        .time {
                            position: absolute;
                            bottom: 10px;
                            right: 10px;
                            font-size: 0.6875rem;
                            color: #c5c5c5;
                        }

                        .paid-button {
                            position: absolute;
                            bottom: 8px;
                            left: 164px;
                            height: 22px;
                            padding: 0 10px;
                            margin-top: 0;
                            font-size: 14px;
                        }
                    }
                }

                .pagination {
                    ::v-deep .el-pagination {
                        width: calc(100% - 30px);
                    }
                }
            }
        }
    }

    @media screen and (min-device-width: 769px) and (max-device-width: 1100px) {
        .top-img {
            width: 100%;
            height: 200px;
        }

        .main {
            .tabs-box {
                width: 700px;
                display: flex;
                margin-top: 30px;
                margin-bottom: 25px;
                .tab {
                    width: 140px;
                    height: 50px;
                    font-size: 1rem;
                    line-height: 50px;
                    margin-right: 36px;
                }
            }

            .list-box {
                width: 700px;

                .list {
                    .list-item {
                        height: 200px;
                        padding: 20px;

                        .date {
                            height: 90px;
                            width: 90px;
                            padding: 15px;
                            box-sizing: border-box;
                            margin-right: 20px;

                            .year-month {
                                font-size: 1rem;
                            }

                            .day {
                                font-size: 1.875rem;
                                margin-top: 5px;
                            }
                        }

                        .content {
                            width: 300px;

                            .title {
                                font-size: 1.25rem;
                            }

                            .sub-title {
                                font-size: 1rem;
                                line-height: 20px;
                                margin-top: 15px;
                            }
                        }

                        .img {
                            width: 240px;
                            height: 160px;
                            margin-left: 20px;
                            object-fit: contain;
                        }
                    }
                }
            }
        }
    }
}
</style>
